import { BULK_ACTION } from 'modules/campaigns/modules/campaigns-reports/components/BulkActionToolbar/bulkAction';
import { getDuplicateDisabledTooltip, getEditDisabledTooltip } from '../creative/bulkActions';

export const bulkActions = [
    {
        key: BULK_ACTION.DELETE,
        handler: () => {},
        enableCondition: () => true,
        getTooltip: () => null,
    },
    {
        key: BULK_ACTION.PLAY,
        handler: () => {},
        enableCondition: () => true,
        getTooltip: () => null,
    },
    {
        key: BULK_ACTION.PAUSE,
        handler: () => {},
        enableCondition: () => true,
        getTooltip: () => null,
    },
    {
        key: BULK_ACTION.EDIT,
        handler: () => {},
        enableCondition: ({ selectedRows = {} }) => !getEditDisabledTooltip(selectedRows)?.disabled,
        getTooltip: ({ selectedRows = {} }) => getEditDisabledTooltip(selectedRows)?.message,
        tooltipOptions: { interactive: true },
    },
    {
        key: BULK_ACTION.DUPLICATE,
        handler: () => {},
        enableCondition: ({ selectedRows = {} }) => !getDuplicateDisabledTooltip(selectedRows)?.disabled,
        getTooltip: ({ selectedRows = {} }) => getDuplicateDisabledTooltip(selectedRows)?.message,
    },
];
